import {useGenericFilters} from 'app/hooks';
import {useAsyncActions} from 'app/utils/redux';

import {convertLocationParamsToFetchParams} from './api';
import {selectPolicyFilters, setPoliciesFilters} from './slice';

import type {PoliciesFetchParamsType} from './types';
import type {Location} from 'history';
import type {InjectedRouter} from 'react-router/lib/Router';
export function usePolicyFilters(
  location: Location<PoliciesFetchParamsType>,
  router: InjectedRouter
) {
  return useGenericFilters(
    location,
    router,
    selectPolicyFilters,
    useAsyncActions({
      setPoliciesFilters,
    }).setPoliciesFilters,
    convertLocationParamsToFetchParams
  );
}
